import React, { useEffect } from "react";

import { sucessInfoModal } from "../../utils/functions";
import Modal from "../../utils/customModal";

const RenderContentModal = ({ title, children, buttons, loading }) => {
  return sucessInfoModal(title, children, buttons, loading);
};

const RenderDefault = ({ loading, onConfirm, onClose }) => (
  <RenderContentModal
    loading={loading}
    title="Eliminación de cuenta"
    buttons={{
      SelBtn: { text: "Sí", action: onConfirm },
      formBtn: { text: "No", action: onClose },
    }}
  >
    <p>¿Está seguro que desea eliminar estos registros?</p>
  </RenderContentModal>
);

const RenderMessage = ({ loading, onOk, messages }) => (
  <RenderContentModal
    loading={loading}
    title={
      messages?.length
        ? "Detalles eliminar facturas"
        : "Eliminación de facturas"
    }
    buttons={{
      formBtn: { text: "Continuar", action: onOk },
    }}
  >
    {messages?.length ? (
      messages
    ) : (
      <p>
        No se pudo realizar la acción, intente más tarde o ponte en contacto con
        nosotros.
      </p>
    )}
  </RenderContentModal>
);

const formatMessageReturn = (data = null) => {
  const { details = [], totalLinesFail = 0 } = data;

  const newMessages = details
    .map((item, index) => {
      return item?.message ? (
        <p key={`text-${index}`}>
          • #{item?.billNumber} {item?.message}
        </p>
      ) : null;
    })
    .filter((i) => i);

  if (!newMessages.length) {
    newMessages.push(
      <p key="error-default">
        {totalLinesFail
          ? "No se pudo realizar la acción, intente más tarde o ponte en contacto con nosotros."
          : "Operación exitosa"}
      </p>
    );
  }

  return newMessages;
};

const DeleteBillModal = ({
  show,
  onCancel,
  onOk,
  instanceAction,
  selectedBills = {},
}) => {
  const [loading, setLoading] = React.useState(false);
  const [messages, setMessage] = React.useState([]);

  const onClose = () => {
    onCancel && onCancel();
  };

  const onConfirm = async () => {
    setLoading(true);
    setMessage([]);

    const bills = Object.keys(selectedBills).map((key) => {
      const { billStatus, billNumber, providerId } = selectedBills[key];
      return {
        billStatus,
        billNumber,
        providerId,
      };
    });

    try {
      const { data } = await instanceAction(
        "/bills/delete-bill",
        "post",
        bills,
        {}
      );

      const _messages = formatMessageReturn(data?.data);
      setMessage(_messages);
    } catch (error) {
      console.log(error?.response?.data);
      const _messages = formatMessageReturn(error?.response?.data?.data);
      setMessage(_messages);
    }

    setLoading(false);
  };

  useEffect(() => {
    if (!show) {
      setLoading(false);
      setMessage([]);
    }
  }, [show]);

  return (
    <Modal show={show}>
      {messages?.length ? (
        <RenderMessage messages={messages} onOk={onOk} loading={loading} />
      ) : (
        <RenderDefault
          onClose={onClose}
          loading={loading}
          onConfirm={onConfirm}
        />
      )}
    </Modal>
  );
};

export default DeleteBillModal;
